import 'phaser'
import { common } from './common-sidecar'

export function getLayers() {
  return layers as ILayers
}

export interface ILayers {
  //main: Phaser.GameObjects.Container

  floor: Phaser.GameObjects.Container
  walls: Phaser.GameObjects.Container
  shadow: Phaser.GameObjects.Container
  highlights: Phaser.GameObjects.Container
  objectsTiles: Phaser.GameObjects.Container
  objects: Phaser.GameObjects.Container

  shipStructure: Phaser.GameObjects.Container
  shipFloor: Phaser.GameObjects.Container
  shipShadow: Phaser.GameObjects.Container
  shipObject: Phaser.GameObjects.Container

  stackedCargo: Phaser.GameObjects.Container
  cargo: Phaser.GameObjects.Container
  machineParts: Phaser.GameObjects.Container
  machines: Phaser.GameObjects.Container
  asteroids: Phaser.GameObjects.Container
  indicators: Phaser.GameObjects.Container
  blueprintsParts: Phaser.GameObjects.Container
  blueprints: Phaser.GameObjects.Container
  monsters: Phaser.GameObjects.Container

  gasses: Phaser.GameObjects.Container

  main: Phaser.GameObjects.Container
  particles: Phaser.GameObjects.Container
  uiOnCam: Phaser.GameObjects.Container
  ui: Phaser.GameObjects.Container
  debug: Phaser.GameObjects.Container
}

let layers: ILayers | null = null
export function create() {
  let scene = common.getPhaserScene()

  //let main = scene.add.container(0, 0)

  layers = {
    //main,

    floor: createLayer(100),
    walls: createLayer(200),
    shadow: createLayer(300),

    objectsTiles: createLayer(400),
    objects: createLayer(450),

    shipStructure: createLayer(455),
    shipFloor: createLayer(460),
    shipShadow: createLayer(465),
    shipObject: createLayer(470),
    machineParts: createLayer(471),
    machines: createLayer(475),
    stackedCargo: createLayer(477),
    asteroids: createLayer(480),
    indicators: createLayer(490),
    monsters: createLayer(500),
    cargo: createLayer(510),

    blueprintsParts: createLayer(539),
    blueprints: createLayer(540),
    highlights: createLayer(550),

    gasses: createLayer(560),

    main: createLayer(600),
    particles: createLayer(700),
    uiOnCam: createLayer(799),
    ui: createLayer(800, true),
    debug: createLayer(900),
  }
  // scene.cameras.main.ignore(layers.ui)
}
export function updateAll() {}

export function setZoom(zoom: number) {
  let ll = getLayers()
  ll.ui.scale = 1 / zoom
}

function createLayer(depth: number, isUi: boolean = false) {
  let scene = common.getPhaserScene()

  // let cam = stevieCam.get()
  // cam.uiCamera.

  let c = scene.add.container(0, 0)
  c.depth = depth

  if (isUi) {
    c.scrollFactorX = 0
    c.scrollFactorY = 0
  }

  // parent.add(c)
  return c
}
